import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowUp } from "lucide-react";
import { business, telHref } from "@/business-config";
import { Wordmark } from "./Header";
export default function Footer({ basePath = "" }) {
  if (basePath) {
    return (
      <footer className="site-footer original-footer">
        <div className="wrap original-footer-inner">
          <Link to={basePath} aria-label="Imperial Cars, pagina principală">
            <Wordmark />
          </Link>
          <span>© {new Date().getFullYear()} {business.legalName}</span>
          <div>
            <Link to="/politica-de-confidentialitate">Confidențialitate</Link>
            <Link to="/politica-de-cookies">Cookies</Link>
          </div>
        </div>
      </footer>
    );
  }
  return (
    <footer className="site-footer">
      <div className="wrap footer-main">
        <Link to="/" aria-label="Imperial Cars, pagina principală">
          <Wordmark />
        </Link>
        <div>
          <span className="small-label">Adresă</span>
          <a
            href={business.address.directionsUrl}
            target="_blank"
            rel="noreferrer"
          >
            Strada Barajului nr. 9 <ArrowUpRight size={16} />
            <br />
            Târgu Mureș, Mureș
          </a>
        </div>
        <div>
          <span className="small-label">Telefon și programări</span>
          <a className="footer-phone" href={telHref()}>
            {business.phone.display}
          </a>
        </div>
      </div>
      <div className="wrap footer-bottom">
        <span>
          © {new Date().getFullYear()} {business.legalName}
        </span>
        <div>
          <Link to="/politica-de-confidentialitate">Confidențialitate</Link>
          <Link to="/politica-de-cookies">Cookies</Link>
        </div>
        <a href="#main">
          Înapoi sus <ArrowUp size={14} />
        </a>
      </div>
    </footer>
  );
}
